import { useState } from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const menuItems = [
    {
      title: 'Research',
      path: '/research',
      dropdown: [
        { title: 'Latest Papers', path: '/research/papers' },
        { title: 'Breakthroughs', path: '/research/breakthroughs' },
        { title: 'Conferences', path: '/research/conferences' },
      ],
    },
    {
      title: 'Tools',
      path: '/tools',
      dropdown: [
        { title: 'Frameworks', path: '/tools/frameworks' },
        { title: 'Libraries', path: '/tools/libraries' },
        { title: 'APIs', path: '/tools/apis' },
      ],
    },
    {
      title: 'Blog',
      path: '/blog',
      dropdown: [
        { title: 'Tutorials', path: '/blog/tutorials' },
        { title: 'Best Practices', path: '/blog/best-practices' },
        { title: 'Case Studies', path: '/blog/case-studies' },
      ],
    },
    {
      title: 'Hardware',
      path: '/hardware',
      dropdown: [
        { title: 'GPUs', path: '/hardware/gpus' },
        { title: 'TPUs', path: '/hardware/tpus' },
        { title: 'Cloud Services', path: '/hardware/cloud' },
      ],
    },
    {
      title: 'Community',
      path: '/community',
      dropdown: [
        { title: 'Forums', path: '/community/forums' },
        { title: 'Events', path: '/community/events' },
        { title: 'Jobs', path: '/community/jobs' },
      ],
    },
  ];

  return (
    <nav className="bg-primary-black text-primary-white sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center">
            <Link to="/" className="text-xl font-bold">
              Trex AI
            </Link>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:block">
            <div className="ml-10 flex items-baseline space-x-4">
              {menuItems.map((item) => (
                <div key={item.title} className="relative group">
                  <Link
                    to={item.path}
                    className="nav-link"
                  >
                    {item.title}
                  </Link>
                  <div className="absolute left-0 mt-2 w-48 rounded-md shadow-lg bg-primary-black ring-1 ring-black ring-opacity-5 hidden group-hover:block">
                    <div className="py-1">
                      {item.dropdown.map((subItem) => (
                        <Link
                          key={subItem.title}
                          to={subItem.path}
                          className="block px-4 py-2 text-sm text-primary-white hover:bg-secondary-blue"
                        >
                          {subItem.title}
                        </Link>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="inline-flex items-center justify-center p-2 rounded-md text-primary-white hover:text-secondary-blue focus:outline-none"
            >
              <span className="sr-only">Open main menu</span>
              {!isOpen ? (
                <svg className="block h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              ) : (
                <svg className="block h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
            {menuItems.map((item) => (
              <div key={item.title}>
                <Link
                  to={item.path}
                  className="block px-3 py-2 rounded-md text-base font-medium text-primary-white hover:bg-secondary-blue"
                >
                  {item.title}
                </Link>
                <div className="pl-4">
                  {item.dropdown.map((subItem) => (
                    <Link
                      key={subItem.title}
                      to={subItem.path}
                      className="block px-3 py-2 rounded-md text-sm text-primary-white hover:bg-secondary-blue"
                    >
                      {subItem.title}
                    </Link>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar; 